import * as API from "utils/api"
import { APIResponse } from "./types"
import { get } from "lodash"

/**
 * 株式銘柄一覧
 */
const EquitySymbolList: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request(
    "GET",
    "Message/EquitySymbolList",
    params,
    headers
  )
}
const SymbolList: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request("GET", "Message/SymbolList", params, headers)
}

const FutureSymbolList: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request(
    "GET",
    "Message/FutureSymbolList",
    params,
    headers
  )
}

const OptionSymbolList: API.RequestAPI<APIResponse.Res | {}> = async (
  params,
  headers
) => {
  return await API.auth_request("GET", "Message/YearMonthList", params, headers)
}

/**
 * 海外指標・為替
 */
const ExchangeSymbolList: API.RequestAPI<APIResponse.Res | {}> = async (
  params,
  headers
) => {
  return await API.request(
    "GET",
    "Equity/Message/ExchangeSymbolList",
    params,
    headers
  )
}

const ForexSymbolDetail: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.request("GET", "Message/ForexSymbolDetail", params, headers)
}

//
// 銘柄詳細
//
const SymbolDetail: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => await API.auth_request("GET", "Message/SymbolDetail", params, headers)

/**
 * 板情報
 */
const EquityOrderBook: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.request("GET", "Equity/Message/OrderBook", params, headers)
}

const DerivativeOrderBook: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.request(
    "GET",
    "Derivative/Message/OrderBook",
    params,
    headers
  )
}

/**
 * 全板情報
 */
//todo utility整える
// const OrderBook: API.RequestAPI<NewsType | {}> = async (symbol: object) => {
//   const params = pick(symbol, ["Symbol", "SecurityType", "Exchange"])
//   const Commodity = GetCommodity(symbol.SecurityType)
//   if (
//     Commodity === app.COMMODITY.EQUITY.id ||
//     Commodity === app.COMMODITY.TRUST.id
//   ) {
//     // 株式
//     return await EquityOrderBook(params)
//   } else {
//     // 先物
//     return await DerivativeOrderBook(params)
//   }
// }

/**
 * 指数銘柄一覧
 */
const IndexSymbolList: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  //todo 型定義すべき
  if (!!get(params, "MiniList"))
    return await API.request(
      "GET",
      "Equity/Message/IndexSymbolList",
      { ...params, _select: "Symbol, ShortName" },
      headers
    )
  else
    return await API.request(
      "GET",
      "Equity/Message/IndexSymbolList",
      params,
      headers
    )
}

/**
 * OPTIONの期間のみ取得
 */
const OptionSymbolYearMonthList: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.request(
    "GET",
    "Derivative/Message/OptionSymbolYearMonthList",
    params,
    headers
  )
}

/**
 * オプションサマリ
 */
const OptionSummary: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.request(
    "GET",
    "Derivative/Message/OptionSummary",
    params,
    headers
  )
}

/**
 * 時価ポーリング
 */
const EquityQutPolling: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.request("GET", "Equity/Message/QutPolling", params, headers)
}

const DerivativeQutPolling: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.request(
    "GET",
    "Derivative/Message/QutPolling",
    params,
    headers
  )
}

/**
 * 銘柄信用情報
 */
const SymbolInfoMargin: API.RequestAPI<APIResponse.Res | {}> = async (
  params,
  headers
) => {
  return await API.auth_request(
    "GET",
    "Message/SymbolInfoMargin",
    params,
    headers
  )
}

/**
 * 銘柄業績一覧情報
 */
const SymbolRecordList: API.RequestAPI<APIResponse.Res | {}> = async (
  params,
  headers
) => {
  return await API.request(
    "GET",
    "Equity/Message/SymbolRecordList",
    params,
    headers
  )
}

/**
 * 企業情報
 */
const GetCompanyInfo: API.RequestAPI<APIResponse.Res | {}> = async (
  params,
  headers
) => {
  return await API.auth_request(
    "GET",
    "Message/GetCompanyInfo",
    params,
    headers
  )
}

/**
 * ETF銘柄一覧
 */
const ETFSymbolList: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  //todo
  // params._where = "Division='0115' OR Division='0116'"
  return await API.request(
    "GET",
    "Equity/Message/ETFSymbolList",
    params,
    headers
  )
}

/**
 * REIT銘柄一覧
 */
const REITSymbolList: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  //todo
  // params._where = "Division='0119'"
  return await API.auth_request(
    "GET",
    "Equity/Message/REITSymbolList",
    params,
    headers
  )
}
/* 信用残(信用証金) */
const GetMarginRemainMarket: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request(
    "GET",
    "Message/GetMarginRemainMarket",
    params,
    headers
  )
}

/* 証金残(信用証金) */
const SyoukinZan: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request(
    "GET",
    "Message/GetDebitAndCreditRemainMarket",
    params,
    headers
  )
}

/* 逆日歩(信用証金) */
const GyakuHibu: API.RequestAPI<APIResponse.Res | {}> = async (
  params: object,
  headers?: object
) => {
  return await API.auth_request("GET", "Message/GyakuHibu", params, headers)
}

/* 株不足(信用証金) */
const GetStockShortage: API.RequestAPI<APIResponse.Res | {}> = async (
  params,
  headers
) => {
  return await API.auth_request(
    "GET",
    "Message/GetStockShortage",
    params,
    headers
  )
}

/**
 * 規制・日々公表銘柄
 */
const GetDailyAnnounceSymbol: API.RequestAPI<APIResponse.Res | {}> = async (
  params,
  headers
) => {
  return await API.auth_request(
    "GET",
    "Message/GetDailyAnnounceSymbol",
    params,
    headers
  )
}

/**
 * 銘柄規制
 */
const GetSymbolRegulation: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request(
    "GET",
    "Message/GetSymbolRegulation",
    params,
    headers
  )
}

const SettledAccountReport: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request(
    "GET",
    "Message/SettledAccountReport",
    params,
    headers
  )
}

const PriceList: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => await API.auth_request("GET", "Message/PriceList", params, headers)

const IndicatorList: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => await API.auth_request("GET", "Message/IndicatorList", params, headers)

const ADRList: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => await API.auth_request("GET", "Message/ADRList", params, headers)

export default {
  SymbolDetail,
  SymbolList,
  IndexSymbolList,
  EquitySymbolList,
  FutureSymbolList,
  OptionSymbolYearMonthList,
  OptionSymbolList,
  OptionSummary,
  ExchangeSymbolList,
  ForexSymbolDetail,
  EquityOrderBook,
  DerivativeOrderBook,
  EquityQutPolling,
  DerivativeQutPolling,
  // OrderBook,
  SymbolInfoMargin,
  SymbolRecordList,
  GetCompanyInfo,
  ETFSymbolList,
  REITSymbolList,
  GetMarginRemainMarket,
  SyoukinZan,
  GyakuHibu,
  GetStockShortage,
  GetDailyAnnounceSymbol,
  GetSymbolRegulation,
  //以下aiから
  PriceList,
  IndicatorList,
  ADRList,
  SettledAccountReport,
}
